import { TLanguage } from '../types/types';

const languageCode: TLanguage = 'en-US';

export default languageCode;
